module.exports = __webpack_public_path__ + "img/76.3.TP.96e303ec.png";